import React from 'react';
import { FadeIn } from './FadeIn';
import { MapPinIcon, MailIcon, PhoneIcon } from 'lucide-react';
export function ContactSection() {
  return <section id="contact" className="py-24 md:py-32 bg-cream" data-id="element-53">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-54">
        <FadeIn className="text-center mb-16" data-id="element-55">
          <span className="text-gold font-semibold tracking-[0.2em] text-sm uppercase mb-4 block" data-id="element-56">
            Get In Touch
          </span>
          <h2 className="text-4xl md:text-5xl font-playfair font-bold text-charcoal mb-6" data-id="element-57">
            Prayer Request & Contact
          </h2>
          <p className="text-charcoal/70 font-inter text-lg max-w-2xl mx-auto" data-id="element-58">
            We would love to hear from you. Send us your prayer request or reach
            out for any inquiries.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12" data-id="element-59">
          {/* Contact Info */}
          <FadeIn delay={0.1} className="lg:col-span-2" data-id="element-60">
            <div className="space-y-8" data-id="element-61">
              <div className="flex items-start gap-5" data-id="element-62">
                <div className="w-12 h-12 bg-gold/10 rounded-full flex items-center justify-center shrink-0" data-id="element-63">
                  <MapPinIcon className="w-6 h-6 text-gold" data-id="element-64" />
                </div>
                <div data-id="element-65">
                  <h4 className="font-semibold text-charcoal mb-1" data-id="element-66">Address</h4>
                  <p className="text-charcoal/70 font-inter" data-id="element-67">
                    3950, 48th Street,
                    <br data-id="element-68" />
                    Bladensburg MD. 20710
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-5" data-id="element-69">
                <div className="w-12 h-12 bg-gold/10 rounded-full flex items-center justify-center shrink-0" data-id="element-70">
                  <MailIcon className="w-6 h-6 text-gold" data-id="element-71" />
                </div>
                <div data-id="element-72">
                  <h4 className="font-semibold text-charcoal mb-1" data-id="element-73">Email</h4>
                  <a href="mailto:info@apostlephillipsministries.org" className="text-charcoal/70 font-inter hover:text-gold transition-colors" data-id="element-74">
                    info@apostlephillipsministries.org
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-5" data-id="element-75">
                <div className="w-12 h-12 bg-gold/10 rounded-full flex items-center justify-center shrink-0" data-id="element-76">
                  <PhoneIcon className="w-6 h-6 text-gold" data-id="element-77" />
                </div>
                <div data-id="element-78">
                  <h4 className="font-semibold text-charcoal mb-1" data-id="element-79">Phone</h4>
                  <a href="tel:+12403939773" className="text-charcoal/70 font-inter hover:text-gold transition-colors" data-id="element-80">
                    (240) 393-9773
                  </a>
                </div>
              </div>
            </div>
          </FadeIn>

          {/* Form */}
          <FadeIn delay={0.2} className="lg:col-span-3" data-id="element-81">
            <form className="bg-white p-8 md:p-12 shadow-xl border border-charcoal/5 rounded-sm" data-id="element-82">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-83">
                <div data-id="element-84">
                  <label htmlFor="firstName" className="block text-sm font-semibold text-charcoal mb-2" data-id="element-85">
                    First Name
                  </label>
                  <input type="text" id="firstName" className="w-full px-4 py-3 bg-cream border border-charcoal/10 focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-colors rounded-sm" placeholder="John" data-id="element-86" />
                </div>
                <div data-id="element-87">
                  <label htmlFor="lastName" className="block text-sm font-semibold text-charcoal mb-2" data-id="element-88">
                    Last Name
                  </label>
                  <input type="text" id="lastName" className="w-full px-4 py-3 bg-cream border border-charcoal/10 focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-colors rounded-sm" placeholder="Doe" data-id="element-89" />
                </div>
              </div>

              <div className="mb-8" data-id="element-90">
                <label htmlFor="email" className="block text-sm font-semibold text-charcoal mb-2" data-id="element-91">
                  Email Address
                </label>
                <input type="email" id="email" className="w-full px-4 py-3 bg-cream border border-charcoal/10 focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-colors rounded-sm" placeholder="john@example.com" data-id="element-92" />
              </div>

              <div className="mb-8" data-id="element-93">
                <label htmlFor="message" className="block text-sm font-semibold text-charcoal mb-2" data-id="element-94">
                  Your Prayer Request or Message
                </label>
                <textarea id="message" rows={5} className="w-full px-4 py-3 bg-cream border border-charcoal/10 focus:border-gold focus:ring-1 focus:ring-gold outline-none transition-colors rounded-sm resize-none" placeholder="Share your prayer request or message with us..." data-id="element-95"></textarea>
              </div>

              <button type="button" className="w-full py-4 bg-gold hover:bg-goldLight text-dark font-semibold tracking-wide transition-colors rounded-sm" data-id="element-96">
                Submit Prayer Request
              </button>
            </form>
          </FadeIn>
        </div>
      </div>
    </section>;
}